import { createContext, useContext, useState, useRef, useCallback } from "react";
import { mediaApi } from "../api";

const PlayerContext = createContext(null);

export function PlayerProvider({ children }) {
  const [current, setCurrent] = useState(null); // { item, autoplay }
  const [playing, setPlaying] = useState(false);
  const [position, setPosition] = useState(0);
  const [duration, setDuration] = useState(0);
  const [minimized, setMinimized] = useState(false);
  const saveTimerRef = useRef(0);

  const play = useCallback(async (item) => {
    setCurrent({ item });
    setPlaying(true);
    setPosition(0);
    setMinimized(false);
    try { await mediaApi.played(item.ID_ConteudoMediaCenter); } catch {}
    try {
      const prog = await mediaApi.getProgress(item.ID_ConteudoMediaCenter);
      if (prog && prog.position > 5 && prog.duration > 0 && prog.position < prog.duration - 15) {
        setPosition(prog.position);
      }
    } catch {}
  }, []);

  const onProgress = useCallback((state) => {
    if (!current) return;
    setPosition(state.playedSeconds);
    // Throttle save to backend every 10s
    const now = Date.now();
    if (now - saveTimerRef.current > 10000 && state.playedSeconds > 1) {
      saveTimerRef.current = now;
      mediaApi
        .saveProgress(current.item.ID_ConteudoMediaCenter, state.playedSeconds, duration || 0, false)
        .catch(() => {});
    }
  }, [current, duration]);

  const onEnded = useCallback(() => {
    if (!current) return;
    mediaApi
      .saveProgress(current.item.ID_ConteudoMediaCenter, duration || 0, duration || 0, true)
      .catch(() => {});
    setPlaying(false);
  }, [current, duration]);

  const close = useCallback(() => {
    setCurrent(null);
    setPlaying(false);
  }, []);

  return (
    <PlayerContext.Provider value={{
      current, playing, position, duration, minimized,
      setPlaying, setPosition, setDuration, setMinimized,
      play, onProgress, onEnded, close,
    }}>
      {children}
    </PlayerContext.Provider>
  );
}

export const usePlayer = () => useContext(PlayerContext);
